(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3825],{

/***/ 95828:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prize-draw/[id]",
      function () {
        return __webpack_require__(17644);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_form_fields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68143);
/* harmony import */ var _components_form_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76817);
/* harmony import */ var _components_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98655);
/* harmony import */ var _contexts_useCampaign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19168);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97859);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47392);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45911);
/* harmony import */ var _utils_helpers_createYupSchema__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69192);
/* harmony import */ var _utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68379);
/* harmony import */ var _utils_schemas__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73705);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46392);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82684);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(75367);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(38797);















const PrizeDraw = (param)=>{
    let { content , tracking , brand , query  } = param;
    const [submitResponse, setSubmitResponse] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)("");
    const { hidden_fields: hiddenFields , fields  } = content;
    const campaign = (0,_contexts_useCampaign__WEBPACK_IMPORTED_MODULE_4__/* .useCampaign */ .y)();
    let initialValues = {};
    const usedFields = [];
    // build initialValues from cms fields
    _utils_schemas__WEBPACK_IMPORTED_MODULE_9__/* .PrizeDrawCmsSchema.forEach */ .EM.forEach((item)=>{
        const found = fields.some((el)=>el.input_type === item.field);
        if (found) {
            var ref;
            if ((ref = item.field) === null || ref === void 0 ? void 0 : ref.includes("_optional")) {
                // eslint-disable-next-line no-param-reassign
                item.id = item.id.replace("_optional", "");
            }
            initialValues[item.id] = item.value || "";
        }
    });
    // remove empty response codes fields
    Object.keys(hiddenFields).forEach((key)=>{
        if (hiddenFields[key] === "" || hiddenFields[key] === null) {
            delete hiddenFields[key];
        }
    });
    // combine all fields
    initialValues = {
        ...initialValues,
        ...hiddenFields,
        is_lexus: brand === "lexus",
        is_dealer: false,
        dealer_name: ""
    };
    // map fields with schemas
    _utils_schemas__WEBPACK_IMPORTED_MODULE_9__/* .PrizeDrawCmsSchema.forEach */ .EM.forEach((item)=>{
        const inputField = {
            ...item
        };
        if (initialValues[inputField.id] !== undefined) {
            // map required fields
            const found = fields.some((el)=>el.optional && el.input_type === inputField.field);
            if (found) {
                inputField.validations = inputField.validations.filter((el)=>el.input_type !== "required");
            }
            usedFields.push(inputField);
        }
    });
    // create global schema
    const yepSchema = usedFields.reduce(_utils_helpers_createYupSchema__WEBPACK_IMPORTED_MODULE_7__/* .createYupSchema */ .E, {});
    const validateSchema = yup__WEBPACK_IMPORTED_MODULE_12__.object().shape(yepSchema);
    const methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_13__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_14__/* .yupResolver */ .X)(validateSchema),
        defaultValues: initialValues,
        mode: "onTouched"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(()=>{
        if (campaign === null || campaign === void 0 ? void 0 : campaign.campaign) {
            methods.setValue("campaign_code", campaign.campaign);
        }
        if (campaign === null || campaign === void 0 ? void 0 : campaign.media) {
            const code = methods.getValues("campaign_code");
            methods.setValue("campaign_code", code + campaign.media);
        }
        if (campaign === null || campaign === void 0 ? void 0 : campaign.brochure) {
            methods.setValue("campaign_response_code", campaign.brochure);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        campaign
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_11__.useEffect)(()=>{
        if (query === null || query === void 0 ? void 0 : query.email) {
            methods.setValue("email", query.email);
        }
        if (query === null || query === void 0 ? void 0 : query.title) {
            methods.setValue("title", query.title);
        }
        if ((query === null || query === void 0 ? void 0 : query.firstname) || (query === null || query === void 0 ? void 0 : query.first_name)) {
            methods.setValue("first_name", query.firstname || query.first_name);
        }
        if ((query === null || query === void 0 ? void 0 : query.lastname) || (query === null || query === void 0 ? void 0 : query.last_name)) {
            methods.setValue("last_name", query.lastname || query.last_name);
        }
    }, [
        query
    ]);
    const DropDownOnChange = (e)=>{
        methods.setValue("preference", e.target.value);
        methods.trigger("preference");
    };
    // Fields builder
    const InputRenderer = (param)=>{
        let { fieldComponents  } = param;
        const Components = {
            DropDown: _components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .DropDown */ .vb,
            Email: _components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Email */ .GT,
            FirstName: _components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .FirstName */ .SW,
            LastName: _components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .LastName */ .uQ,
            Tel: _components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Tel */ .ki,
            Tel_optional: _components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Tel */ .ki,
            Title: _components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Title */ .Dx
        };
        return fieldComponents.map((field, key)=>{
            const FieldComp = Components[field.input_type] || null;
            const props = {};
            if (FieldComp) {
                if (field.input_type.includes("_optional")) {
                    props.optional = true;
                }
                if (field.helper) props.helper = field.helper;
                if (field.input_type === "DropDown") {
                    props.options = content.options;
                    props.name = "preference";
                    props.label = "Event Selection";
                    props.onChange = DropDownOnChange;
                }
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FieldComp, {
                ...props
            }, key);
        });
    };
    const PrizeDrawFields = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputRenderer, {
            fieldComponents: content.fields
        }), content.fields);
    const onSubmit = async (data)=>{
        setSubmitResponse("");
        await (0,axios__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)({
            method: "post",
            url: "".concat("https://api.toyota.co.uk/forms/api", "/prize-draw"),
            headers: {
                "Content-Type": "application/json"
            },
            data
        }).then(()=>{
            (0,_utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_8__/* .formEvent */ .Be)({
                conversion: 1,
                name: tracking.form,
                step: "form-submit",
                variant: tracking.variant,
                page: tracking.page
            });
            (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .closeOverlay */ .Km)(content.confirmation.title, content.confirmation.copy, setSubmitResponse);
        }).catch(()=>{
            (0,_utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_8__/* .formEvent */ .Be)({
                conversion: 0,
                name: tracking.form,
                step: "form-error",
                variant: tracking.variant,
                page: tracking.page
            });
            setSubmitResponse(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .ERROR_MESSAGE */ .c9);
            throw new Error(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .ERROR_MESSAGE */ .c9);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui__WEBPACK_IMPORTED_MODULE_3__/* .Nav */ .JL, {
                title: content.title,
                background: content.background,
                color: content === null || content === void 0 ? void 0 : content.font_colour
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormWrapper */ .n, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormStep */ .p, {
                    title: content.details.title,
                    subtitle: content.details.subtitle,
                    step: 1,
                    active: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_13__/* .FormProvider */ .RV, {
                        ...methods,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                            onSubmit: methods.handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AuthFill */ .Pl, {}),
                                PrizeDrawFields,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .MarketingConsent */ .nb, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    submitResponse: submitResponse,
                                    children: content.details.submit
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
PrizeDraw.whyDidYouRender = true;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PrizeDraw);


/***/ }),

/***/ 69192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ createYupSchema; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38797);
/* eslint-disable no-param-reassign */ 
function createYupSchema(schema, config) {
    const { id , validationType , validations =[]  } = config;
    if (!yup__WEBPACK_IMPORTED_MODULE_0__[validationType]) {
        return schema;
    }
    let validator = yup__WEBPACK_IMPORTED_MODULE_0__[validationType]();
    validations.forEach((validation)=>{
        const { params , type  } = validation;
        if (!validator[type]) {
            return;
        }
        if (type === "when") {
            const [field, options] = params;
            validator = validator.when(field, (value, conditionSchema)=>{
                if (options.is(value)) {
                    return conditionSchema.required(options.then.message).trim();
                }
                return conditionSchema;
            });
        } else {
            validator = validator[type](...params);
        }
    });
    schema[id] = validator;
    return schema;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7409,1850,9595,9516,8655,4817,9774,2888,179], function() { return __webpack_exec__(95828); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);